import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "userListingPage" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Manage your "),
  /*#__PURE__*/_createElementVNode("span", null, "users")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Create User ")
const _hoisted_5 = { class: "tableSec" }
const _hoisted_6 = { class: "actionblock" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("No access")
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Admin cannot be deleted")
const _hoisted_11 = { class: "deleI" }
const _hoisted_12 = {
  key: 3,
  class: "deleI"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("No access")
const _hoisted_14 = {
  key: 0,
  class: "spinners"
}
const _hoisted_15 = { class: "UserformContent" }
const _hoisted_16 = { class: "overflowDiv" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Admin")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Manager")
const _hoisted_19 = { class: "footersec" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_21 = { class: "user_permission" }
const _hoisted_22 = { class: "bodySec" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { id: "addPrivilagesec" }
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_28 = { class: "footersec" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Discard")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Update")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.commonService.checkPermission('User', 'create'))
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            size: "large",
            block: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createNewUser()))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_a_table, {
        columns: _ctx.userColumns,
        "data-source": _ctx.userLists,
        class: "",
        rowKey: "id",
        pagination: false,
        rowClassName: 
          (record, index) => (record.status == 'active' ? 'active' : 'inactive')
        
      }, {
        status: _withCtx(({ record }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["status", record.status === 'inactive' ? 'Disabled' : ''])
          }, _toDisplayString(record.status), 3)
        ]),
        action: _withCtx(({ record }) => [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.commonService.checkPermission('User', 'edit'))
              ? (_openBlock(), _createBlock(_component_EditOutlined, {
                  key: 0,
                  onClick: ($event: any) => (_ctx.editUser(record)),
                  style: { fontSize: '20px' }
                }, null, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_a_tooltip, { key: 1 }, {
                  title: _withCtx(() => [
                    _hoisted_7
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_EditOutlined, { style: { fontSize: '20px' } })
                  ]),
                  _: 1
                })),
            (_ctx.commonService.checkPermission('User', 'delete'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (record.role_id != 2)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "deleI",
                        onClick: ($event: any) => (_ctx.showDeleteConfirm(record.id))
                      }, [
                        _createVNode(_component_DeleteOutlined)
                      ], 8, _hoisted_9))
                    : (_openBlock(), _createBlock(_component_a_tooltip, { key: 1 }, {
                        title: _withCtx(() => [
                          _hoisted_10
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_DeleteOutlined)
                          ])
                        ]),
                        _: 1
                      }))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _hoisted_13
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_DeleteOutlined)
                    ]),
                    _: 1
                  })
                ]))
          ])
        ]),
        _: 1
      }, 8, ["columns", "data-source", "rowClassName"])
    ]),
    (_ctx.pageLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      title: _ctx.addEditUserTitle,
      width: "700px",
      class: "candidate-dashboard-modal userPmodal",
      visible: _ctx.creatUserVisible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.creatUserVisible) = $event)),
      "cancel-button-props": { style: 'display:none' },
      "ok-button-props": { style: 'display:none' },
      maskClosable: false,
      destroyOnClose: true,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.userTabKey,
          "onUpdate:activeKey": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userTabKey) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: "Personal Info"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_a_form, {
                    ref: "userFormRef",
                    model: _ctx.userFormModal,
                    rules: _ctx.userFormRules,
                    "label-col": _ctx.labelCol,
                    "wrapper-col": _ctx.wrapperCol,
                    colon: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_a_form_item, {
                          label: "First Name",
                          required: "",
                          name: "first_name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.userFormModal.first_name,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userFormModal.first_name) = $event)),
                              type: "text",
                              placeholder: "",
                              "allow-clear": "",
                              autocomplete: "off"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "Last Name",
                          required: "",
                          name: "last_name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.userFormModal.last_name,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userFormModal.last_name) = $event)),
                              type: "text",
                              placeholder: "",
                              "allow-clear": "",
                              autocomplete: "off"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          ref: "email",
                          required: "",
                          label: "Email",
                          name: "email"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: "",
                              value: _ctx.userFormModal.email,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userFormModal.email) = $event)),
                              type: "text",
                              "allow-clear": "",
                              autocomplete: "off",
                              disabled: _ctx.addEditUserTitle === 'Edit User'
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_a_form_item, {
                          label: "Permission",
                          required: "",
                          name: "role_id"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.userFormModal.role_id,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userFormModal.role_id) = $event)),
                              placeholder: "Select Permission"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: "2" }, {
                                  default: _withCtx(() => [
                                    _hoisted_17
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "3" }, {
                                  default: _withCtx(() => [
                                    _hoisted_18
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          ref: "userstatus",
                          label: "Active Account",
                          name: "userstatus"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_switch, {
                              checked: _ctx.userFormModal.userstatus,
                              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userFormModal.userstatus) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_a_button, {
                          class: "cancle",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancelUserModal()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          class: "add",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addNewUser(_ctx.userFormModal))),
                          loading: _ctx.confirmLoading
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.saveText), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model", "rules", "label-col", "wrapper-col"])
                ])
              ]),
              _: 1
            }),
            (
            _ctx.userFormModal.role_id !== '2' &&
            _ctx.saveText === 'Update' &&
            _ctx.showPermissionTab
          )
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "2",
                  tab: "Permission"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allUserPermissions, (value, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index.toString(),
                            class: "pageSec"
                          }, [
                            _createElementVNode("h4", _hoisted_23, _toDisplayString(value.name), 1),
                            _createElementVNode("div", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.data, (x, y) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "custom-control custom-checkbox",
                                  key: y
                                }, [
                                  _createElementVNode("label", {
                                    class: "custom-control-label",
                                    for: x.url
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: x.url,
                                      "onUpdate:modelValue": ($event: any) => ((x.value) = $event),
                                      value: "true",
                                      disabled: x.type == 'view'
                                    }, null, 8, _hoisted_26), [
                                      [_vModelCheckbox, x.value]
                                    ]),
                                    _hoisted_27,
                                    _createTextVNode(" " + _toDisplayString(x.type), 1)
                                  ], 8, _hoisted_25)
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_a_button, {
                          class: "cancel",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cancelUserModal()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          class: "add",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateUserPermission())),
                          loading: _ctx.permissionLoading
                        }, {
                          default: _withCtx(() => [
                            _hoisted_30
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ]))
}